import { useDispatch, useSelector } from "react-redux";
import {
  productModalErrorsSelector,
  setProductModalVisibility,
} from "src/features/product-modal/productModalSlice";
import ProductButton from "../products/components/ProductButton";
import ProductImage from "../products/components/ProductImage";
import ProductName from "../products/components/ProductName";
import ProductPrice from "../products/components/ProductPrice";
import ProductModalStatus from "./components/ProductModalStatus";
import Variants from "./components/variants/Variants";
import useProductModal from "./hooks/useProductModal";
import { DivProductModal } from "./style/ProductModal.style";

interface Props {}

const ProductModal = (props: Props) => {
  const errors = useSelector(productModalErrorsSelector);
  const dispatch = useDispatch();

  const {
    isDetailFetching,
    isVisible,
    toggleProductParams,
    status,
    product,
    onAddToCart,
  } = useProductModal();
  const {
    image,
    price,
    name,
    url,
    enabledVariants,
    variants,
    productDiscount,
  } = product;

  function closeModal() {
    dispatch(setProductModalVisibility(false));
  }

  return (
    <>
      <DivProductModal className="akn-modal-container" $isVisible={isVisible}>
        <div className={"akn-modal-container-inner"}>
          <ProductModalStatus isLoading={isDetailFetching} status={status} />
          <span className="akn-modal-close" onClick={closeModal}>
            ✖
          </span>
          <ProductImage src={image} variant="modal" />
          <div className="akn-modal-details">
            <ProductName name={name} variant="modal" />
            <ProductPrice
              price={price}
              showCoupon={true}
              discount={productDiscount}
              showCopyIcon={true}
              showDiscount={true}
              showRetailPrice={true}
            />
            <Variants
              enabledVariants={enabledVariants}
              toggleProductParams={toggleProductParams}
              variants={variants}
              errors={errors}
              isLoading={isDetailFetching}
            />
            <ProductButton onClick={onAddToCart} href={url} />
          </div>
        </div>
      </DivProductModal>
    </>
  );
};

export default ProductModal;
